
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("9HkI0", function(module, exports) {
var $11a26bbb19c50c31$exports = {};

var $awSkB = parcelRequire("awSkB");


var $aYYGS = parcelRequire("aYYGS");

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $11a26bbb19c50c31$var$_nodeId;
var $11a26bbb19c50c31$var$_clockseq;
// Previous uuid creation time
var $11a26bbb19c50c31$var$_lastMSecs = 0;
var $11a26bbb19c50c31$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $11a26bbb19c50c31$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $11a26bbb19c50c31$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $11a26bbb19c50c31$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $awSkB();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $11a26bbb19c50c31$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $11a26bbb19c50c31$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $11a26bbb19c50c31$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $11a26bbb19c50c31$var$_lastMSecs + (nsecs - $11a26bbb19c50c31$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $11a26bbb19c50c31$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $11a26bbb19c50c31$var$_lastMSecs = msecs;
    $11a26bbb19c50c31$var$_lastNSecs = nsecs;
    $11a26bbb19c50c31$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $aYYGS(b);
}
$11a26bbb19c50c31$exports = $11a26bbb19c50c31$var$v1;



var $kyKWe = parcelRequire("kyKWe");

var $70f83188ef1bd34f$var$uuid = $kyKWe;
$70f83188ef1bd34f$var$uuid.v1 = $11a26bbb19c50c31$exports;
$70f83188ef1bd34f$var$uuid.v4 = $kyKWe;
module.exports = $70f83188ef1bd34f$var$uuid;

});

parcelRegister("kyKWe", function(module, exports) {

var $awSkB = parcelRequire("awSkB");


var $aYYGS = parcelRequire("aYYGS");

function $ef7b6490dc24dd32$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $awSkB)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $aYYGS(rnds);
}
module.exports = $ef7b6490dc24dd32$var$v4;

});

parcelRegister("fvqz5", function(module, exports) {
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $b49e5b83abcdd205$var$warning = function() {};
module.exports = $b49e5b83abcdd205$var$warning;

});

parcelRegister("bKqeQ", function(module, exports) {

var $ddnoW = parcelRequire("ddnoW");


var $dsvEp = parcelRequire("dsvEp");

function $88d858015cfbe7a1$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries2) {
        const retryDelaySeconds = Math.pow(2, retries2);
        await new Promise((resolve)=>setTimeout(resolve, retryDelaySeconds * 1e3 + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $88d858015cfbe7a1$var$isLikeCloseEvent, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == "x" ? r : r & 3 | 8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$88d858015cfbe7a1$var$isWebSocket(webSocketImpl)) throw new Error("Invalid WebSocket implementation provided");
        ws = webSocketImpl;
    } else if (typeof WebSocket !== "undefined") ws = WebSocket;
    else if (typeof $parcel$global !== "undefined") ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== "undefined") ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    const emitter = (()=>{
        const message = /* @__PURE__ */ (()=>{
            const listeners2 = {};
            return {
                on (id, listener) {
                    listeners2[id] = listener;
                    return ()=>{
                        delete listeners2[id];
                    };
                },
                emit (message2) {
                    if ("id" in message2) listeners2[message2.id]?.(message2);
                }
            };
        })();
        const listeners = {
            connecting: on?.connecting ? [
                on.connecting
            ] : [],
            opened: on?.opened ? [
                on.opened
            ] : [],
            connected: on?.connected ? [
                on.connected
            ] : [],
            ping: on?.ping ? [
                on.ping
            ] : [],
            pong: on?.pong ? [
                on.pong
            ] : [],
            message: on?.message ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: on?.closed ? [
                on.closed
            ] : [],
            error: on?.error ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    const i = l.indexOf(listener);
                    if (i > -1) l.splice(i, 1);
                };
            },
            emit (event, ...args) {
                for (const listener of [
                    ...listeners[event]
                ])listener(...args);
            }
        };
    })();
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on("error", (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on("closed", (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting ?? (connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    if (!locks) {
                        connecting = void 0;
                        return denied({
                            code: 1e3,
                            reason: "All Subscriptions Gone"
                        });
                    }
                    retries++;
                }
                emitter.emit("connecting", retrying);
                const socket2 = new WebSocketImpl(typeof url === "function" ? await url() : url, (0, $dsvEp.G));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing);
                        queuedPing = setTimeout(()=>{
                            if (socket2.readyState === WebSocketImpl.OPEN) {
                                socket2.send((0, $dsvEp.s)({
                                    type: (0, $dsvEp.M).Ping
                                }));
                                emitter.emit("ping", false, void 0);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = void 0;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $88d858015cfbe7a1$export$f5b1bfead8e118a7) {
                        socket2.close(4499, "Terminated");
                        socket2.onerror = null;
                        socket2.onclose = null;
                    }
                });
                socket2.onerror = (err)=>emitter.emit("error", err);
                socket2.onclose = (event)=>emitter.emit("closed", event);
                socket2.onopen = async ()=>{
                    try {
                        emitter.emit("opened", socket2);
                        const payload = typeof connectionParams === "function" ? await connectionParams() : connectionParams;
                        if (socket2.readyState !== WebSocketImpl.OPEN) return;
                        socket2.send((0, $dsvEp.s)(payload ? {
                            type: (0, $dsvEp.M).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $dsvEp.M).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket2.close((0, $dsvEp.C).ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
                        }, connectionAckWaitTimeout);
                        enqueuePing();
                    } catch (err) {
                        emitter.emit("error", err);
                        socket2.close((0, $dsvEp.C).InternalClientError, (0, $dsvEp.l)(err instanceof Error ? err.message : String(err), "Internal client error"));
                    }
                };
                let acknowledged = false;
                socket2.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $dsvEp.p)(data, reviver);
                        emitter.emit("message", message);
                        if (message.type === "ping" || message.type === "pong") {
                            emitter.emit(message.type, true, message.payload);
                            if (message.type === "pong") enqueuePing();
                            else if (!disablePong) {
                                socket2.send((0, $dsvEp.s)(message.payload ? {
                                    type: (0, $dsvEp.M).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $dsvEp.M).Pong
                                }));
                                emitter.emit("pong", false, message.payload);
                            }
                            return;
                        }
                        if (acknowledged) return;
                        if (message.type !== (0, $dsvEp.M).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit("connected", socket2, message.payload, retrying);
                        retrying = false;
                        retries = 0;
                        connected([
                            socket2,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket2.onmessage = null;
                        emitter.emit("error", err);
                        socket2.close((0, $dsvEp.C).BadResponse, (0, $dsvEp.l)(err instanceof Error ? err.message : String(err), "Bad response"));
                    }
                };
            })())));
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{};
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        const complete = ()=>socket.close(1e3, "Normal Closure");
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    function shouldRetryConnectOrThrow(errOrCloseEvent) {
        if ($88d858015cfbe7a1$var$isLikeCloseEvent(errOrCloseEvent) && ($88d858015cfbe7a1$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $dsvEp.C).InternalServerError,
            (0, $dsvEp.C).InternalClientError,
            (0, $dsvEp.C).BadRequest,
            (0, $dsvEp.C).BadResponse,
            (0, $dsvEp.C).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $dsvEp.C).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $dsvEp.C).SubscriberAlreadyExists,
            (0, $dsvEp.C).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        if (disposed) return false;
        if ($88d858015cfbe7a1$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1e3) return locks > 0;
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        return retrying = true;
    }
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose;
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent2) {
                return onNonLazyError?.(errOrCloseEvent2);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $dsvEp.M).Next:
                            sink.next(message.payload);
                            return;
                        case (0, $dsvEp.M).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $dsvEp.M).Complete:
                            done = true;
                            releaser();
                            return;
                    }
                });
                socket.send((0, $dsvEp.s)({
                    id: id,
                    type: (0, $dsvEp.M).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) socket.send((0, $dsvEp.s)({
                        id: id,
                        type: (0, $dsvEp.M).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return;
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            if (!errored) sink.complete();
        }).catch((err)=>{
            sink.error(err);
        });
        return ()=>{
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{}
            };
            const dispose = subscribe(request, {
                next (val) {
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = async function* iterator2() {
                for(;;){
                    if (!pending.length) await new Promise((resolve)=>deferred.resolve = resolve);
                    while(pending.length)yield pending.shift();
                    if (deferred.error) throw deferred.error;
                    if (deferred.done) return;
                }
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: void 0
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: void 0
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                const [socket] = await connecting;
                socket.close(1e3, "Normal Closure");
            }
        },
        terminate () {
            if (connecting) emitter.emit("closed", new $88d858015cfbe7a1$export$f5b1bfead8e118a7());
        }
    };
}
class $88d858015cfbe7a1$export$f5b1bfead8e118a7 extends Error {
    constructor(...args){
        super(...args), (0, $ddnoW._)(this, "name", "TerminatedCloseEvent"), (0, $ddnoW._)(this, "message", "4499: Terminated"), (0, $ddnoW._)(this, "code", 4499), (0, $ddnoW._)(this, "reason", "Terminated"), (0, $ddnoW._)(this, "wasClean", false);
    }
}
function $88d858015cfbe7a1$var$isLikeCloseEvent(val) {
    return (0, $dsvEp.i)(val) && "code" in val && "reason" in val;
}
function $88d858015cfbe7a1$var$isFatalInternalCloseCode(code) {
    if ([
        1e3,
        // Normal Closure is not an erroneous close code
        1001,
        // Going Away
        1006,
        // Abnormal Closure
        1005,
        // No Status Received
        1012,
        // Service Restart
        1013,
        // Try Again Later
        1014
    ].includes(code)) return false;
    return code >= 1e3 && code <= 1999;
}
function $88d858015cfbe7a1$var$isWebSocket(val) {
    return typeof val === "function" && "constructor" in val && "CLOSED" in val && "CLOSING" in val && "CONNECTING" in val && "OPEN" in val;
}
module.exports["createClient"] = $88d858015cfbe7a1$export$5d730b7aed1a3eb0;

});

parcelRegister("8aej1", function(module, exports) {

var $kJOOQ = parcelRequire("kJOOQ");

function $5f1a5abef19d6af7$var$_toConsumableArray(arr) {
    return $5f1a5abef19d6af7$var$_arrayWithoutHoles(arr) || $5f1a5abef19d6af7$var$_iterableToArray(arr) || $5f1a5abef19d6af7$var$_unsupportedIterableToArray(arr) || $5f1a5abef19d6af7$var$_nonIterableSpread();
}
function $5f1a5abef19d6af7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5f1a5abef19d6af7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5f1a5abef19d6af7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5f1a5abef19d6af7$var$_arrayLikeToArray(o, minLen);
}
function $5f1a5abef19d6af7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $5f1a5abef19d6af7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5f1a5abef19d6af7$var$_arrayLikeToArray(arr);
}
function $5f1a5abef19d6af7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */ var $5f1a5abef19d6af7$var$routerMiddleware = function routerMiddleware(history) {
    return function(store) {
        return function(next) {
            return function(action) {
                // eslint-disable-line no-unused-vars
                if (action.type !== (0, $kJOOQ.CALL_HISTORY_METHOD)) return next(action);
                var _action$payload = action.payload, method = _action$payload.method, args = _action$payload.args;
                history[method].apply(history, $5f1a5abef19d6af7$var$_toConsumableArray(args));
            };
        };
    };
};
var $5f1a5abef19d6af7$export$2e2bcd8739ae039 = $5f1a5abef19d6af7$var$routerMiddleware;
module.exports["default"] = $5f1a5abef19d6af7$export$2e2bcd8739ae039;

});

parcelRegister("kJOOQ", function(module, exports) {
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */ var $f18f6e3856e45eb6$export$be84bd1ba815d4c2 = '@@router/LOCATION_CHANGE';
var $f18f6e3856e45eb6$export$924382de27029fe1 = function onLocationChanged(location, action) {
    var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return {
        type: $f18f6e3856e45eb6$export$be84bd1ba815d4c2,
        payload: {
            location: location,
            action: action,
            isFirstRendering: isFirstRendering
        }
    };
};
var $f18f6e3856e45eb6$export$d035cdafa5d37a89 = '@@router/CALL_HISTORY_METHOD';
var $f18f6e3856e45eb6$var$updateLocation = function updateLocation(method) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return {
            type: $f18f6e3856e45eb6$export$d035cdafa5d37a89,
            payload: {
                method: method,
                args: args
            }
        };
    };
};
var $f18f6e3856e45eb6$export$4cbf152802aa238 = $f18f6e3856e45eb6$var$updateLocation('push');
var $f18f6e3856e45eb6$export$77ad94ebf1c2b9ed = $f18f6e3856e45eb6$var$updateLocation('replace');
var $f18f6e3856e45eb6$export$93bb224d05b3906d = $f18f6e3856e45eb6$var$updateLocation('go');
var $f18f6e3856e45eb6$export$28fca2ccfd38b8f = $f18f6e3856e45eb6$var$updateLocation('goBack');
var $f18f6e3856e45eb6$export$994d0e87e52ba8e3 = $f18f6e3856e45eb6$var$updateLocation('goForward');
var $f18f6e3856e45eb6$export$95755023e698c378 = {
    push: $f18f6e3856e45eb6$export$4cbf152802aa238,
    replace: $f18f6e3856e45eb6$export$77ad94ebf1c2b9ed,
    go: $f18f6e3856e45eb6$export$93bb224d05b3906d,
    goBack: $f18f6e3856e45eb6$export$28fca2ccfd38b8f,
    goForward: $f18f6e3856e45eb6$export$994d0e87e52ba8e3
};
module.exports["LOCATION_CHANGE"] = $f18f6e3856e45eb6$export$be84bd1ba815d4c2;
module.exports["onLocationChanged"] = $f18f6e3856e45eb6$export$924382de27029fe1;
module.exports["CALL_HISTORY_METHOD"] = $f18f6e3856e45eb6$export$d035cdafa5d37a89;
module.exports["push"] = $f18f6e3856e45eb6$export$4cbf152802aa238;
module.exports["replace"] = $f18f6e3856e45eb6$export$77ad94ebf1c2b9ed;

});

parcelRegister("dBmJE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $bEYte = parcelRequire("bEYte");


var $KDAt0 = parcelRequire("KDAt0");


var $4xJJk = parcelRequire("4xJJk");


var $kJOOQ = parcelRequire("kJOOQ");




function $939a539a2666a339$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $939a539a2666a339$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $939a539a2666a339$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $939a539a2666a339$var$_typeof(obj);
}
var $939a539a2666a339$var$createSelectors = function createSelectors(structure) {
    var getIn = structure.getIn, toJS = structure.toJS;
    var isRouter = function isRouter(value) {
        return value != null && $939a539a2666a339$var$_typeof(value) === 'object' && getIn(value, [
            'location'
        ]) && getIn(value, [
            'action'
        ]);
    };
    var getRouter = function getRouter(state) {
        var router = toJS(getIn(state, [
            'router'
        ]));
        if (!isRouter(router)) throw 'Could not find router reducer in state tree, it must be mounted under "router"';
        return router;
    };
    var getLocation = function getLocation(state) {
        return toJS(getIn(getRouter(state), [
            'location'
        ]));
    };
    var getAction = function getAction(state) {
        return toJS(getIn(getRouter(state), [
            'action'
        ]));
    };
    var getSearch = function getSearch(state) {
        return toJS(getIn(getRouter(state), [
            'location',
            'search'
        ]));
    };
    var getHash = function getHash(state) {
        return toJS(getIn(getRouter(state), [
            'location',
            'hash'
        ]));
    }; // It only makes sense to recalculate the `matchPath` whenever the pathname
    // of the location changes. That's why `createMatchSelector` memoizes
    // the latest result based on the location's pathname.
    var createMatchSelector = function createMatchSelector(path) {
        var lastPathname = null;
        var lastMatch = null;
        return function(state) {
            var _ref = getLocation(state) || {}, pathname = _ref.pathname;
            if (pathname === lastPathname) return lastMatch;
            lastPathname = pathname;
            var match = (0, $KDAt0.matchPath)(pathname, path);
            if (!match || !lastMatch || match.url !== lastMatch.url // When URL matched for nested routes, URL is the same but isExact is not.
             || match.isExact !== lastMatch.isExact) lastMatch = match;
            return lastMatch;
        };
    };
    return {
        getLocation: getLocation,
        getAction: getAction,
        getRouter: getRouter,
        getSearch: getSearch,
        getHash: getHash,
        createMatchSelector: createMatchSelector
    };
};
var $939a539a2666a339$export$2e2bcd8739ae039 = $939a539a2666a339$var$createSelectors;


function $f3f655976ac56086$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f3f655976ac56086$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f3f655976ac56086$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f3f655976ac56086$var$_typeof(obj);
}
function $f3f655976ac56086$var$_extends() {
    $f3f655976ac56086$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f3f655976ac56086$var$_extends.apply(this, arguments);
}
function $f3f655976ac56086$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f3f655976ac56086$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f3f655976ac56086$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f3f655976ac56086$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f3f655976ac56086$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f3f655976ac56086$var$_createSuper(Derived) {
    return function() {
        var Super = $f3f655976ac56086$var$_getPrototypeOf(Derived), result;
        if ($f3f655976ac56086$var$_isNativeReflectConstruct()) {
            var NewTarget = $f3f655976ac56086$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f3f655976ac56086$var$_possibleConstructorReturn(this, result);
    };
}
function $f3f655976ac56086$var$_possibleConstructorReturn(self, call) {
    if (call && ($f3f655976ac56086$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f3f655976ac56086$var$_assertThisInitialized(self);
}
function $f3f655976ac56086$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f3f655976ac56086$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f3f655976ac56086$var$_getPrototypeOf(o) {
    $f3f655976ac56086$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f3f655976ac56086$var$_getPrototypeOf(o);
}
function $f3f655976ac56086$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f3f655976ac56086$var$_setPrototypeOf(subClass, superClass);
}
function $f3f655976ac56086$var$_setPrototypeOf(o, p) {
    $f3f655976ac56086$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f3f655976ac56086$var$_setPrototypeOf(o, p);
}
var $f3f655976ac56086$var$createConnectedRouter = function createConnectedRouter(structure) {
    var _createSelectors = (0, $939a539a2666a339$export$2e2bcd8739ae039)(structure), getLocation = _createSelectors.getLocation;
    /*
   * ConnectedRouter listens to a history object passed from props.
   * When history is changed, it dispatches action to redux store.
   * Then, store will pass props to component to render.
   * This creates uni-directional flow from history->store->router->components.
   */ var ConnectedRouter = /*#__PURE__*/ function(_PureComponent) {
        $f3f655976ac56086$var$_inherits(ConnectedRouter, _PureComponent);
        var _super = $f3f655976ac56086$var$_createSuper(ConnectedRouter);
        function ConnectedRouter(props) {
            var _this;
            $f3f655976ac56086$var$_classCallCheck(this, ConnectedRouter);
            _this = _super.call(this, props);
            var store = props.store, history = props.history, onLocationChanged = props.onLocationChanged, stateCompareFunction = props.stateCompareFunction;
            _this.inTimeTravelling = false; // Subscribe to store changes to check if we are in time travelling
            _this.unsubscribe = store.subscribe(function() {
                // Allow time travel debugging compatibility to be turned off
                // as the detection for this (below) is error prone in apps where the
                // store may be unmounted, a navigation occurs, and then the store is re-mounted
                // during the app's lifetime. Detection could be much improved if Redux DevTools
                // simply set a global variable like `REDUX_DEVTOOLS_IS_TIME_TRAVELLING=true`.
                var isTimeTravelDebuggingAllowed = !props.noTimeTravelDebugging; // Extract store's location
                var _getLocation = getLocation(store.getState()), pathnameInStore = _getLocation.pathname, searchInStore = _getLocation.search, hashInStore = _getLocation.hash, stateInStore = _getLocation.state; // Extract history's location
                var _history$location = history.location, pathnameInHistory = _history$location.pathname, searchInHistory = _history$location.search, hashInHistory = _history$location.hash, stateInHistory = _history$location.state; // If we do time travelling, the location in store is changed but location in history is not changed
                if (isTimeTravelDebuggingAllowed && props.history.action === 'PUSH' && (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore || !(0, (/*@__PURE__*/$parcel$interopDefault($4xJJk)))(stateInStore, stateInHistory, stateCompareFunction))) {
                    _this.inTimeTravelling = true; // Update history's location to match store's location
                    history.push({
                        pathname: pathnameInStore,
                        search: searchInStore,
                        hash: hashInStore,
                        state: stateInStore
                    });
                }
            });
            var handleLocationChange = function handleLocationChange(location, action) {
                var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                // Dispatch onLocationChanged except when we're in time travelling
                if (!_this.inTimeTravelling) onLocationChanged(location, action, isFirstRendering);
                else _this.inTimeTravelling = false;
            }; // Listen to history changes
            _this.unlisten = history.listen(handleLocationChange);
            if (!props.noInitialPop) // Dispatch a location change action for the initial location.
            // This makes it backward-compatible with react-router-redux.
            // But, we add `isFirstRendering` to `true` to prevent double-rendering.
            handleLocationChange(history.location, history.action, true);
            return _this;
        }
        $f3f655976ac56086$var$_createClass(ConnectedRouter, [
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.unlisten();
                    this.unsubscribe();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, omitRouter = _this$props.omitRouter, history = _this$props.history, children = _this$props.children; // The `omitRouter` option is available for applications that must
                    // have a Router instance higher in the component tree but still desire
                    // to use connected-react-router for its Redux integration.
                    if (omitRouter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.Router), {
                        history: history
                    }, children);
                }
            }
        ]);
        return ConnectedRouter;
    }((0, $cozmU.PureComponent));
    ConnectedRouter.propTypes = {
        store: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).shape({
            getState: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
            subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
        }).isRequired,
        history: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).shape({
            action: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
            listen: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
            location: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
            push: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
        }).isRequired,
        basename: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node
        ]),
        onLocationChanged: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
        noInitialPop: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
        noTimeTravelDebugging: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
        stateCompareFunction: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
        omitRouter: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            onLocationChanged: function onLocationChanged(location, action, isFirstRendering) {
                return dispatch((0, $kJOOQ.onLocationChanged)(location, action, isFirstRendering));
            }
        };
    };
    var ConnectedRouterWithContext = function ConnectedRouterWithContext(props) {
        var Context = props.context || (0, $bEYte.ReactReduxContext);
        if (Context == null) throw 'Please upgrade to react-redux v6';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Context.Consumer, null, function(_ref) {
            var store = _ref.store;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ConnectedRouter, $f3f655976ac56086$var$_extends({
                store: store
            }, props));
        });
    };
    ConnectedRouterWithContext.propTypes = {
        context: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object
    };
    return (0, $bEYte.connect)(null, mapDispatchToProps)(ConnectedRouterWithContext);
};
var $f3f655976ac56086$export$2e2bcd8739ae039 = $f3f655976ac56086$var$createConnectedRouter;





function $c90219660dd7d6b0$var$_slicedToArray(arr, i) {
    return $c90219660dd7d6b0$var$_arrayWithHoles(arr) || $c90219660dd7d6b0$var$_iterableToArrayLimit(arr, i) || $c90219660dd7d6b0$var$_unsupportedIterableToArray(arr, i) || $c90219660dd7d6b0$var$_nonIterableRest();
}
function $c90219660dd7d6b0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c90219660dd7d6b0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c90219660dd7d6b0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c90219660dd7d6b0$var$_arrayLikeToArray(o, minLen);
}
function $c90219660dd7d6b0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c90219660dd7d6b0$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c90219660dd7d6b0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c90219660dd7d6b0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c90219660dd7d6b0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c90219660dd7d6b0$var$ownKeys(Object(source), true).forEach(function(key) {
            $c90219660dd7d6b0$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c90219660dd7d6b0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c90219660dd7d6b0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Adds query to location.
 * Utilises the search prop of location to construct query.
 */ var $c90219660dd7d6b0$var$injectQuery = function injectQuery(location) {
    if (location && location.query) // Don't inject query if it already exists in history
    return location;
    var searchQuery = location && location.search;
    if (typeof searchQuery !== 'string' || searchQuery.length === 0) return $c90219660dd7d6b0$var$_objectSpread({}, location, {
        query: {}
    });
     // Ignore the `?` part of the search string e.g. ?username=codejockie
    var search = searchQuery.substring(1); // Split the query string on `&` e.g. ?username=codejockie&name=Kennedy
    var queries = search.split('&'); // Contruct query
    var query = queries.reduce(function(acc, currentQuery) {
        // Split on `=`, to get key and value
        var _currentQuery$split = currentQuery.split('='), _currentQuery$split2 = $c90219660dd7d6b0$var$_slicedToArray(_currentQuery$split, 2), queryKey = _currentQuery$split2[0], queryValue = _currentQuery$split2[1];
        return $c90219660dd7d6b0$var$_objectSpread({}, acc, $c90219660dd7d6b0$var$_defineProperty({}, queryKey, queryValue));
    }, {});
    return $c90219660dd7d6b0$var$_objectSpread({}, location, {
        query: query
    });
};
var $c90219660dd7d6b0$var$createConnectRouter = function createConnectRouter(structure) {
    var fromJS = structure.fromJS, merge = structure.merge;
    var createRouterReducer = function createRouterReducer(history) {
        var initialRouterState = fromJS({
            location: $c90219660dd7d6b0$var$injectQuery(history.location),
            action: history.action
        });
        /*
    * This reducer will update the state with the most recent location history
    * has transitioned to.
    */ return function() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRouterState;
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, type = _ref.type, payload = _ref.payload;
            if (type === (0, $kJOOQ.LOCATION_CHANGE)) {
                var location = payload.location, action = payload.action, isFirstRendering = payload.isFirstRendering; // Don't update the state ref for the first rendering
                // to prevent the double-rendering issue on initilization
                return isFirstRendering ? state : merge(state, {
                    location: fromJS($c90219660dd7d6b0$var$injectQuery(location)),
                    action: action
                });
            }
            return state;
        };
    };
    return createRouterReducer;
};
var $c90219660dd7d6b0$export$2e2bcd8739ae039 = $c90219660dd7d6b0$var$createConnectRouter;



/* Code from github.com/erikras/redux-form by Erik Rasmussen */ var $f316cad0c3083d2a$var$getIn = function getIn(state, path) {
    if (!state) return state;
    var length = path.length;
    if (!length) return undefined;
    var result = state;
    for(var i = 0; i < length && !!result; ++i)result = result[path[i]];
    return result;
};
var $f316cad0c3083d2a$export$2e2bcd8739ae039 = $f316cad0c3083d2a$var$getIn;


function $1c6a996509ccc70c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c6a996509ccc70c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1c6a996509ccc70c$var$ownKeys(Object(source), true).forEach(function(key) {
            $1c6a996509ccc70c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1c6a996509ccc70c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1c6a996509ccc70c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1c6a996509ccc70c$var$structure = {
    fromJS: function fromJS(value) {
        return value;
    },
    getIn: (0, $f316cad0c3083d2a$export$2e2bcd8739ae039),
    merge: function merge(state, payload) {
        return $1c6a996509ccc70c$var$_objectSpread({}, state, {}, payload);
    },
    toJS: function toJS(value) {
        return value;
    }
};
var $1c6a996509ccc70c$export$2e2bcd8739ae039 = $1c6a996509ccc70c$var$structure;






var $8aej1 = parcelRequire("8aej1");

var $9e705dd855a29e46$export$28f92b8268ba8447 = /*#__PURE__*/ (0, $f3f655976ac56086$export$2e2bcd8739ae039)((0, $1c6a996509ccc70c$export$2e2bcd8739ae039));
var $9e705dd855a29e46$export$2c021ec3f68e26bf = /*#__PURE__*/ (0, $c90219660dd7d6b0$export$2e2bcd8739ae039)((0, $1c6a996509ccc70c$export$2e2bcd8739ae039));
var $9e705dd855a29e46$var$_createSelectors = /*#__PURE__*/ (0, $939a539a2666a339$export$2e2bcd8739ae039)((0, $1c6a996509ccc70c$export$2e2bcd8739ae039)), $9e705dd855a29e46$export$e7fd20fad3cf4b5f = $9e705dd855a29e46$var$_createSelectors.getLocation, $9e705dd855a29e46$export$6ca3170acb89054 = $9e705dd855a29e46$var$_createSelectors.getAction, $9e705dd855a29e46$export$adaba664e531641c = $9e705dd855a29e46$var$_createSelectors.getHash, $9e705dd855a29e46$export$3b1eb3bad78dcdd4 = $9e705dd855a29e46$var$_createSelectors.getRouter, $9e705dd855a29e46$export$786f9a4bc80cc6b0 = $9e705dd855a29e46$var$_createSelectors.getSearch, $9e705dd855a29e46$export$a7b4d762fce9f62a = $9e705dd855a29e46$var$_createSelectors.createMatchSelector;
module.exports["ConnectedRouter"] = $9e705dd855a29e46$export$28f92b8268ba8447;
module.exports["connectRouter"] = $9e705dd855a29e46$export$2c021ec3f68e26bf;

});

parcelRegister("awSkB", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $7aa70995ad661ded$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($7aa70995ad661ded$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $7aa70995ad661ded$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $7aa70995ad661ded$var$getRandomValues($7aa70995ad661ded$var$rnds8);
        return $7aa70995ad661ded$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $7aa70995ad661ded$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $7aa70995ad661ded$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $7aa70995ad661ded$var$rnds;
    };
}

});

parcelRegister("aYYGS", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $7fee95d74ddd92b1$var$byteToHex = [];
for(var $7fee95d74ddd92b1$var$i = 0; $7fee95d74ddd92b1$var$i < 256; ++$7fee95d74ddd92b1$var$i)$7fee95d74ddd92b1$var$byteToHex[$7fee95d74ddd92b1$var$i] = ($7fee95d74ddd92b1$var$i + 0x100).toString(16).substr(1);
function $7fee95d74ddd92b1$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $7fee95d74ddd92b1$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $7fee95d74ddd92b1$var$bytesToUuid;

});

parcelRegister("dsvEp", function(module, exports) {
function $9cc671136dcf5e2e$var$extendedTypeof(val) {
    if (val === null) return "null";
    if (Array.isArray(val)) return "array";
    return typeof val;
}
function $9cc671136dcf5e2e$export$23f2a1d2818174ef(val) {
    return $9cc671136dcf5e2e$var$extendedTypeof(val) === "object";
}
function $9cc671136dcf5e2e$export$8b22cf2602fb60ce(val) {
    return typeof Object(val)[Symbol.asyncIterator] === "function";
}
function $9cc671136dcf5e2e$export$407448d2b89b1813(val) {
    return $9cc671136dcf5e2e$export$23f2a1d2818174ef(val) && typeof Object(val)[Symbol.asyncIterator] === "function" && typeof val.return === "function";
}
function $9cc671136dcf5e2e$var$areGraphQLFormattedErrors(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>"message" in ob);
}
function $9cc671136dcf5e2e$export$882b5998b3b9117c(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}
const $9cc671136dcf5e2e$export$2329c99376c9d0a4 = "graphql-transport-ws";
const $9cc671136dcf5e2e$export$96f57966bedc81b4 = "graphql-ws";
var $9cc671136dcf5e2e$export$e7094788287c5e9b = /* @__PURE__ */ ((CloseCode2)=>{
    CloseCode2[CloseCode2["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode2[CloseCode2["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode2[CloseCode2["BadRequest"] = 4400] = "BadRequest";
    CloseCode2[CloseCode2["BadResponse"] = 4004] = "BadResponse";
    CloseCode2[CloseCode2["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode2[CloseCode2["Forbidden"] = 4403] = "Forbidden";
    CloseCode2[CloseCode2["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode2[CloseCode2["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode2[CloseCode2["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    CloseCode2[CloseCode2["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode2[CloseCode2["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
    return CloseCode2;
})($9cc671136dcf5e2e$export$e7094788287c5e9b || {});
var $9cc671136dcf5e2e$export$3a1a48c8f6ef640e = /* @__PURE__ */ ((MessageType2)=>{
    MessageType2["ConnectionInit"] = "connection_init";
    MessageType2["ConnectionAck"] = "connection_ack";
    MessageType2["Ping"] = "ping";
    MessageType2["Pong"] = "pong";
    MessageType2["Subscribe"] = "subscribe";
    MessageType2["Next"] = "next";
    MessageType2["Error"] = "error";
    MessageType2["Complete"] = "complete";
    return MessageType2;
})($9cc671136dcf5e2e$export$3a1a48c8f6ef640e || {});
function $9cc671136dcf5e2e$export$90a7f3efeed30595(val) {
    if (!$9cc671136dcf5e2e$export$23f2a1d2818174ef(val)) throw new Error(`Message is expected to be an object, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== "string") throw new Error(`Message is expects the 'type' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.type)}`);
    switch(val.type){
        case "connection_init" /* ConnectionInit */ :
        case "connection_ack" /* ConnectionAck */ :
        case "ping" /* Ping */ :
        case "pong" /* Pong */ :
            if (val.payload != null && !$9cc671136dcf5e2e$export$23f2a1d2818174ef(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case "subscribe" /* Subscribe */ :
            if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!$9cc671136dcf5e2e$export$23f2a1d2818174ef(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload)}`);
            if (typeof val.payload.query !== "string") throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload.query)}`);
            if (val.payload.variables != null && !$9cc671136dcf5e2e$export$23f2a1d2818174ef(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload.variables)}`);
            if (val.payload.operationName != null && $9cc671136dcf5e2e$var$extendedTypeof(val.payload.operationName) !== "string") throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload.operationName)}`);
            if (val.payload.extensions != null && !$9cc671136dcf5e2e$export$23f2a1d2818174ef(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload.extensions)}`);
            break;
        case "next" /* Next */ :
            if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!$9cc671136dcf5e2e$export$23f2a1d2818174ef(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload)}`);
            break;
        case "error" /* Error */ :
            if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!$9cc671136dcf5e2e$var$areGraphQLFormattedErrors(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case "complete" /* Complete */ :
            if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $9cc671136dcf5e2e$export$ffb5f4729a158638(data, reviver) {
    return $9cc671136dcf5e2e$export$90a7f3efeed30595(typeof data === "string" ? JSON.parse(data, reviver) : data);
}
function $9cc671136dcf5e2e$export$2408f22a0fab9ae5(msg, replacer) {
    $9cc671136dcf5e2e$export$90a7f3efeed30595(msg);
    return JSON.stringify(msg, replacer);
}
module.exports["i"] = $9cc671136dcf5e2e$export$23f2a1d2818174ef;
module.exports["l"] = $9cc671136dcf5e2e$export$882b5998b3b9117c;
module.exports["G"] = $9cc671136dcf5e2e$export$2329c99376c9d0a4;
module.exports["C"] = $9cc671136dcf5e2e$export$e7094788287c5e9b;
module.exports["M"] = $9cc671136dcf5e2e$export$3a1a48c8f6ef640e;
module.exports["p"] = $9cc671136dcf5e2e$export$ffb5f4729a158638;
module.exports["s"] = $9cc671136dcf5e2e$export$2408f22a0fab9ae5;

});


$parcel$global.rlb("aZinD")
//# sourceMappingURL=vendors.27b2ea3c.js.map
